import { toast } from "react-toastify";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import useLeadNotes from "common/datahooks/useLeadNotes";

export default function DeleteNoteDialog({
  profileId,
  noteId,
  onClose,
}: {
  profileId: string;
  noteId: string;
  onClose: () => void;
}) {
  const { deleteLeadNote, isDeletingLeadNote } = useLeadNotes();

  function onDelete() {
    deleteLeadNote({ profileId, noteId }).catch(() => {
      toast.error("Error deleting Note");
    });
    onClose();
  }
  return (
    <Dialog
      open={!!noteId}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onClose();
        }
      }}
    >
      <DialogContent>
        <DialogHeader
          title="Delete note?"
          subtitle="Are you sure you want to delete this note?"
        />
        <DialogFooter className="justify-end">
          <Button
            variant="ghost-black"
            disabled={isDeletingLeadNote}
            onClick={onClose}
          >
            No
          </Button>
          <Button
            variant="outline-danger"
            onClick={onDelete}
            isLoading={isDeletingLeadNote}
          >
            Yes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
